import { render } from "./MegaNavigation.vue?vue&type=template&id=094e67b9"
import script from "./MegaNavigation.vue?vue&type=script&lang=js"
export * from "./MegaNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__